import type { HeaderInitials } from 'common/models';
import { useCustomTranslation } from 'helpers/translationHelper';
import React from 'react';

import AddressBlock from './AddressBlock';

interface OwnProps {
  customer: HeaderInitials;
  withTitle?: boolean;
  title?: string;
}

const CustomerBlock = (props: OwnProps) => {
  const { customer, withTitle, title } = props;
  const { t } = useCustomTranslation();

  return (
    <div className="Customer">
      {withTitle && <div className="BlockHeader">{title}</div>}
      <div className="Name">{customer.name}</div>
      <AddressBlock address={customer.address} />
      {customer.identificationNumber && (
        <div>
          {t('customData.company.identificationNumber', { number: customer.identificationNumber })}
        </div>
      )}
      {customer.taxNumber && (
        <div>{t('customData.company.taxNumber', { number: customer.taxNumber })}</div>
      )}
    </div>
  );
};

export default CustomerBlock;
